var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dropdown-menu boards-dropdown" },
    [
      _c(
        "draggable",
        {
          key: _vm.nonce,
          staticClass: "pl-0",
          attrs: {
            animation: 200,
            "ghost-class": "ghost",
            handle: ".dropdown-item-drag-handle",
          },
          model: {
            value: _vm.orderedBoards,
            callback: function ($$v) {
              _vm.orderedBoards = $$v
            },
            expression: "orderedBoards",
          },
        },
        [
          _c(
            "transition-group",
            { attrs: { type: "transition", name: "flip-list" } },
            _vm._l(_vm.orderedBoards, function (ref) {
              var name = ref.name
              var owner = ref.owner
              var ownerDetails = ref.ownerDetails
              var isDefault = ref.default
              var id = ref.id
              var numberOfClients = ref.numberOfClients
              return _c(
                "div",
                {
                  key: id,
                  staticClass:
                    "d-flex flex-row align-items-center justify-content-between dropdown-item",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text-truncate clickable board-link",
                      class: _vm.boardId === id ? "disabled" : "",
                      attrs: { title: name },
                      on: {
                        click: function ($event) {
                          return _vm.handleClick(id, $event)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "bold d-flex flex-row align-items-center",
                        },
                        [
                          isDefault && owner
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-primary px-4 ml-0 mr-1",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("global.words.default")) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(name) +
                                "\n            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("boards.messages.boardOwner")) +
                            ":\n            " +
                            _vm._s(ownerDetails.givenName) +
                            " " +
                            _vm._s(ownerDetails.familyName) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(numberOfClients) +
                            "\n            " +
                            _vm._s(
                              _vm.$tc(
                                "global.doorr.client",
                                parseInt(numberOfClients)
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.order
                    ? _c(
                        "span",
                        { staticClass: "ml-2 dropdown-item-drag-handle" },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v(" menu "),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.create
        ? _c(
            "a",
            {
              staticClass:
                "dropdown-item create-new-board pl-4 mb-1 p-2 clickable",
              on: { click: _vm.handleCreateClick },
            },
            [
              _c("span", { staticClass: "oblique" }, [
                _vm._v(_vm._s(_vm.$t("boards.actions.createNewBoard"))),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }